import React from 'react';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import default_avatar from 'assets/images/default_avatar.svg';
import { CardStyles } from './cardsStyles';
import { useTranslation } from 'react-i18next';
import AcceptOrDecline from './common/acceptOrDecline';
import DisplayRoles from './common/displayRoles';
import { CompanySummaryInterface } from 'services/finance/models/access/companyAccess';
import { WpTypography } from '@wagepoint/ui-toolkit/components/wp-typography/wpTypography';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import WpPill from '@wagepoint/ui-toolkit/components/wp-pill/wpPill';

interface IProps {
  item: CompanySummaryInterface;
}

const PendingCardApprover: React.FC<IProps> = ({ item }) => {
  const classes = CardStyles();
  const { t } = useTranslation(['userAccounts']);

  return (
    <Card variant="outlined">
      <CardHeader
        title={
          <div className={classes.cardHeader}>
            <img src={default_avatar} alt={t('firmInviteSent.default')} className={classes.defaultImage} />
            <WpTypography variant="h3">{item.name}</WpTypography>
            <WpPill color="orange" label={t('firmInviteAccepted.chipLabel')} />
          </div>
        }
        action={<AcceptOrDecline item={item} />}
      />
      <CardContent>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <div>
              <WpTypography variant="p1Bold" display="inline">
                {t('firmInviteAccepted.request')}
              </WpTypography>
              <WpTypography display="inline">{item.ownerName}</WpTypography>
            </div>
          </Grid>
          <DisplayRoles item={item} />
        </Grid>
      </CardContent>
    </Card>
  );
};

export default PendingCardApprover;
